/**
 * ChoiceModal - Dropdown selection modal for GM prompts
 * date_of_change: 2025-11-05
 * rule_reference: AGENTS.md (separate rules engine from presentation; provide GM hooks; no silent fallbacks)
 */
import React, { useState, useEffect } from 'react';
import BattleRoomDialog from './BattleRoomDialog';

const ChoiceModal = ({
  visible = false,
  title = 'Select',
  prompt = 'Choose one',
  options = [],
  initialValue = '',
  onConfirm,
  onCancel
}) => {
  const [value, setValue] = useState(initialValue || (options[0] || ''));
  const hasOptions = options.length > 0;

  useEffect(() => {
    if (visible) {
      setValue(initialValue || (options[0] || ''));
    }
  }, [visible, initialValue, options]);

  if (!visible) return null;

  return (
    <BattleRoomDialog
      visible={visible}
      eyebrow="Game Master choice"
      title={title}
      description={prompt}
      onRequestClose={onCancel}
      footer={(
        <>
          <button
            type="button"
            className="battle-room-dialog__button battle-room-dialog__button--quiet"
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            type="button"
            className="battle-room-dialog__button battle-room-dialog__button--primary"
            disabled={!hasOptions}
            onClick={() => onConfirm && onConfirm(value)}
          >
            Confirm
          </button>
        </>
      )}
    >
      <div className="battle-room-dialog__field">
        <label className="battle-room-dialog__label" htmlFor="battle-room-choice">Choose an option</label>
        <select
          id="battle-room-choice"
          className="battle-room-dialog__select"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          data-battle-dialog-autofocus
        >
          {options.map((opt) => (
            <option key={opt} value={opt}>{opt}</option>
          ))}
        </select>
        {!hasOptions && (
          <p className="battle-room-dialog__hint battle-room-dialog__validation">
            No options are available for this decision.
          </p>
        )}
      </div>
    </BattleRoomDialog>
  );
};

export default ChoiceModal;
